module.exports = __webpack_public_path__ + "static/media/mail.184ca930.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/images/mail.png
// module id = 133
// module chunks = 0